import {
  ACCOMPLISHMENT,
  AFFILIATION,
  CERTIFICATION,
  SKILL,
  SUMMARY,
  WORK_EXPERIENCE,
} from '@glass/common/modules/content/deprecatedContentTypes';

const resourceOrder = [SKILL, WORK_EXPERIENCE, SUMMARY, ACCOMPLISHMENT, AFFILIATION, CERTIFICATION];

export default resourceOrder;
